import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import QuoraVersion_1_0 from './pages/sdks/Quora/QuoraVersion_1_0';
import PawareVisionVersion_1_0 from './pages/sdks/PawareVision/PawareVisionVersion_1_0';
import PawareDataVersion_1_0 from './pages/sdks/PawareData/PawareDataVersion_1_0';
import HomePage from './pages/HomePage';
import BigensDemo from './pages/demos/BigensDemo';
import CinelaserDemo from './pages/demos/CinelaserDemo';
import GabrielSantosDemo from './pages/demos/GabrielSantosDemo';

export default function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pages/sdks/Quora/Version_1_0" element={<QuoraVersion_1_0 />} />
        <Route path="/pages/sdks/PawareVision/Version_1_0" element={<PawareVisionVersion_1_0 />} />
        <Route path="/pages/sdks/PawareData/Version_1_0" element={<PawareDataVersion_1_0 />} />
        
        {/* Rotas de Demo */}
        <Route path="/bigens-demo" element={<BigensDemo />} />
        <Route path="/cinelaser-demo" element={<CinelaserDemo />} />
        <Route path="/gabrielsantos-demo" element={<GabrielSantosDemo />} />
      </Routes>
    </Router>
  );
}